<div class="FcAgEditor__Dropdown--Text" (mousedown)="toggleDropdown($event)">
    {{getName(activeItem || group)}}
</div>

<div class="FcAgEditor__Dropdown--DropdownMenu" *ngIf="isDropdownOpen">
    <div class="FcAgEditor__Dropdown--Item" *ngFor="let item of items; trackBy: trackByIndex"
         (mousedown)="onClick($event, item)"
         [ngClass]="{'FcAgEditor__Dropdown--Active': item === activeItem, 'FcAgEditor--Disabled':disabledItems.includes(item)}">
        {{getName(item)}}
    </div>
</div>
